import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { PetitionBuilderService } from 'src/app/services/petition-builder.service';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { I140PetitionFee } from 'src/app/data/models/petition-fee.model';
import { NgForm } from '@angular/forms';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { map } from 'rxjs/internal/operators/map';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { AppServicesLibraryService } from 'app-services-library';

@Component({
  selector: 'app-fee-calculation',
  templateUrl: './fee-calculation.component.html',
  styleUrls: ['./fee-calculation.component.scss']
})
export class FeeCalculationComponent implements OnInit {

  @ViewChild('feeCalculationForm', { static: true }) feeCalculationForm: NgForm;
  feeCalculation: I140PetitionFee[];
  serviceCenterSelectedId: number;
  disabledControls: boolean;
  checked: boolean;
  clonedFees: { [s: string]: I140PetitionFee; };
  stepDetails: TaskStep;
  feeTotal: number;
  enableEdit: boolean = false;

  observableSubscription$ = new Subject();

  constructor(
    private toastr: ToastrService,
    private store: Store<any>,
    private pbService: PetitionBuilderService,
    public dynamicDialogConfig: DynamicDialogConfig,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.disabledControls = false;
    this.checked = true;
    this.clonedFees = {};
    this.feeTotal = 0;
  }

  ngOnInit(): void {
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.stepDetails = data;
      this.getFeeCalculation();
      this.toggleControlsStatus();
    });

    this.feeCalculationForm.form.valueChanges.pipe(
      map(() => this.feeCalculationForm.dirty),
    ).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
      if (dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  getFeeCalculation() {
    this.pbService.getFeeCalculation(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId).subscribe((response: ImagilityBaseResponse) => {
      if (response && response['data']) {
        this.feeCalculation = response['data'] as [];
        this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
      }
    });
  }

  resetFeeCalucation() {
    this.pbService.resetFeeCalculation(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId).subscribe((response: ImagilityBaseResponse) => {
      if (response && response['data']) {
        this.feeCalculation = response['data'] as [];
        this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
        this.toastr.success(response.message, 'Success');
      }
    });
  }

  postFeeCalculation() {
    this.pbService.postFeeCalculation(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, this.feeCalculation).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
      this.toastr.success(response.message, 'Success');
      this.feeCalculation = response.data;
      this.feeCalculationForm.resetForm();
    });
  }

  onRowEditInit(item: I140PetitionFee) {
    this.clonedFees[item.feeTypeCode] = { ...item };
  }

  onRowEditSave(item: I140PetitionFee) {    
    if (parseInt(item.applicableFee) > 0) {
      item.isCustomized = 1;
      delete this.clonedFees[item.feeTypeCode];
      this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
    }
  }

  onRowEditCancel(item: I140PetitionFee, index: number) {
    this.feeCalculation[index] = this.clonedFees[item.feeTypeCode];
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  updateControls(status: boolean) {
    this.enableEdit = status;
  }

  formatTooltip(item: string){
    return item.replace(/,/g, '\n');
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
